import React, { useMemo } from "react";
import { Box, Paper, Typography, Stack, useTheme } from "@mui/material";
import {
  Assessment as AssessmentIcon,
  TrendingUp as HighRiskIcon,
  Warning as WarningIcon,
  HelpOutline as HelpIcon,
} from "@mui/icons-material";
import { RISK_LEVELS, REVIEW_STATES } from "../../utils/constants";
import { styles } from "../../styles/Vendors.styles";

const VendorSummary = ({ vendors = [] }) => {
  const theme = useTheme();

  const stats = useMemo(() => {
    const active = vendors.filter((v) => v.status !== "Archived");
    return {
      total: active.length,
      critical: active.filter(
        (v) => v.inherentRisk === RISK_LEVELS.CRITICAL || v.inherentRisk === RISK_LEVELS.HIGH
      ).length,
      overdue: active.filter((v) => v.reviewState === REVIEW_STATES.OVERDUE).length,
      unscored: active.filter(
        (v) => !v.inherentRisk || v.inherentRisk === RISK_LEVELS.UNSCORED
      ).length,
    };
  }, [vendors]);

  return (
    <Box sx={{ mb: 4 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <Paper elevation={0} sx={styles.statsCard}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="h5" fontWeight="600" color={theme.customColors.text.strong}>
                {stats.total}
              </Typography>
              <Typography variant="body2" color={theme.customColors.text.secondary}>
                Active Vendors
              </Typography>
            </Box>
            <AssessmentIcon sx={{ color: theme.customColors.icons.primary, fontSize: 24 }} />
          </Box>
        </Paper>

        <Paper elevation={0} sx={styles.statsCard}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="h5" fontWeight="600" color={theme.customColors.status.error.text}>
                {stats.critical}
              </Typography>
              <Typography variant="body2" color={theme.customColors.text.secondary}>
                High / Critical Risk
              </Typography>
            </Box>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                backgroundColor: theme.customColors.status.error.main,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <HighRiskIcon sx={{ color: theme.customColors.button.text, fontSize: 16 }} />
            </Box>
          </Box>
        </Paper>

        <Paper elevation={0} sx={styles.statsCard}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="h5" fontWeight="600" color={theme.customColors.status.warning.text}>
                {stats.overdue}
              </Typography>
              <Typography variant="body2" color={theme.customColors.text.secondary}>
                Overdue Reviews
              </Typography>
            </Box>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                backgroundColor: theme.customColors.status.warning.main,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WarningIcon sx={{ color: theme.customColors.button.text, fontSize: 16 }} />
            </Box>
          </Box>
        </Paper>

        <Paper elevation={0} sx={styles.statsCard}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="h5" fontWeight="600" color={theme.customColors.text.secondary}>
                {stats.unscored}
              </Typography>
              <Typography variant="body2" color={theme.customColors.text.secondary}>
                Unscored Vendors
              </Typography>
            </Box>
            <HelpIcon sx={{ color: theme.customColors.icons.disabled, fontSize: 24 }} />
          </Box>
        </Paper>
      </Stack>
    </Box>
  );
};

export default VendorSummary;
